<script lang="ts">import { cfgTelegramLink, cfgToThemeCdnPath, stateTheme, stateUi, Theme } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, toSiteUrl } from "@infinitro/global";
import { TelegramIcon } from "@infinitro/icons";
import Seal from "./seal.svelte";
import SocialMedia from "./social-media.svelte";
const GAMBLE_AWARE_LINK = "https://www.gambleaware.org/";
const DMCA_HELPER_SRC = "https://images.dmca.com/Badges/DMCABadgeHelper.min.js";
const DMCA_TITLE = "DMCA.com Protection Status";
let copyrightVerbiage = $derived(`${$stateTheme}_all_rights_reserved`);
let useRegulatorySeal = $derived($stateTheme === Theme.Turboslots);
let dmca = $derived($stateUi.footer?.dmca);
const telegramLink = cfgTelegramLink();
let dmcaHref = $derived(dmca ? `https://www.dmca.com/Protection/Status.aspx?ID=${dmca.protectionId}` : "");
let dmcaImgSrc = $derived(dmca ? `https://images.dmca.com/Badges/DMCA_badge_grn_60w.png?ID=${dmca.protectionId}` : "");
</script>

<svelte:head>
	{#if dmca}
		<script src={DMCA_HELPER_SRC}></script>
	{/if}
</svelte:head>

<div>
	{#if telegramLink}
		<!-- eslint-disable-next-line svelte/no-navigation-without-resolve -->
		<a
			class="telegram-follow-button"
			href={telegramLink}
			target="_blank"
			rel="noopener noreferrer"
			aria-label={$t(Verbiage.telegram_follow)}
			title={$t(Verbiage.telegram_follow)}
		>
			<TelegramIcon />
		</a>
	{/if}
	<div class="footer-badges-social">
		<div class="footer-badges">
			<!-- badges -->
			<a href={`${toSiteUrl('/terms-of-service/', $loggedIn)}#point-18`}>
				<img
					src={cfgToThemeCdnPath(`/footer/a18+.png`)}
					alt={$t(Verbiage.logo_alt, 'alts')}
					style="height:56px"
				/>
			</a>
			{#if $loggedIn}
				{#if useRegulatorySeal}
					<Seal />
				{:else}
					<img style="height:37px" src={cfgToThemeCdnPath(`/footer/tr-check.png`)} alt="tr-check" />
				{/if}
			{/if}
			{#if dmca}
				<a
					href={dmcaHref}
					title={DMCA_TITLE}
					class="dmca-badge"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img src={dmcaImgSrc} alt={DMCA_TITLE} class="h-10" />
				</a>
			{/if}
			<a href={GAMBLE_AWARE_LINK} target="_blank" rel="noopener noreferrer">
				<img
					style="height:20px"
					src={cfgToThemeCdnPath(`/footer/gambleaware.png`)}
					alt="gambleaware"
				/>
			</a>
		</div>
		<div>
			<SocialMedia />
		</div>
	</div>
	{#if $loggedIn}
		<p class="footer-copyright">
			{$t(copyrightVerbiage)}
		</p>
	{/if}
</div>

<style>
	.footer-badges-social {
		display: flex;
		flex-direction: column-reverse;
		gap: 1rem
}

@media (min-width: 768px) {

		.footer-badges-social {
				flex-direction: row;
				align-items: center;
				justify-content: space-between
		}
}

	.telegram-follow-button {
		margin-bottom: 1.25rem;
		display: flex;
		height: 40px;
		width: 100%;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
		border-width: 0px;
		text-decoration-line: none;
		background: #1990d8
}

	.telegram-follow-button :global(svg) {
		height: 20px;
		width: 20px
}

	@media (min-width: 768px) {
		.telegram-follow-button {
				margin-left: auto;
				margin-bottom: 0px;
				height: 32px;
				width: 32px;
				border-radius: 3px
		}

		.telegram-follow-button :global(svg) {
				height: 16px;
				width: 16px
		}
	}

	.footer-badges {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		gap: 0.75rem
}

	@media (min-width: 768px) {

		.footer-badges {
				justify-content: flex-start
		}
}

	.footer-copyright {
		font-size: 0.75rem;
		line-height: 1rem;
		color: var(--color-text-300);
		margin-top: 2rem;
		margin-bottom: 1rem
}
</style>
